import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../config/axios';
import { formatError } from '../utils/errorHandler';
import './RequestSupport.css';

const CATEGORY_OPTIONS = [
  { value: 'bug', labelKey: 'categoryBug' },
  { value: 'billing', labelKey: 'categoryBilling' },
  { value: 'account', labelKey: 'categoryAccount' },
  { value: 'feature', labelKey: 'categoryFeature' },
  { value: 'other', labelKey: 'categoryOther' }
];

const RequestSupport = () => {
  const { t } = useTranslation('support');
  const [subject, setSubject] = useState('');
  const [category, setCategory] = useState('bug');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      await axios.post('/api/support', {
        subject,
        category,
        message
      });
      setSuccess(t('successMessage'));
      setSubject('');
      setCategory('bug');
      setMessage('');
    } catch (submitError) {
      if (submitError.response?.status === 503) {
        setError(t('unavailable'));
      } else {
        setError(formatError(submitError) || t('failedSubmit'));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="request-support-page">
      <div className="container main-content">
        <div className="page-header request-support-header">
          <h1>{t('pageTitle')}</h1>
          <p className="request-support-subtitle">{t('subtitle')}</p>
        </div>

        {error && (
          <div className="request-support-banner request-support-banner--error" role="alert">
            {error}
          </div>
        )}
        {success && (
          <div className="request-support-banner request-support-banner--success" role="status">
            {success}
          </div>
        )}

        <form className="request-support-form" onSubmit={handleSubmit}>
          <h2 className="request-support-section-eyebrow">{t('sectionEyebrow')}</h2>

          <div className="form-group">
            <label htmlFor="support-subject">{t('subjectLabel')}</label>
            <input
              id="support-subject"
              type="text"
              value={subject}
              onChange={(event) => setSubject(event.target.value)}
              placeholder={t('subjectPlaceholder')}
              maxLength={200}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="support-category">{t('categoryLabel')}</label>
            <select
              id="support-category"
              value={category}
              onChange={(event) => setCategory(event.target.value)}
              required
            >
              {CATEGORY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {t(option.labelKey)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="support-message">{t('messageLabel')}</label>
            <textarea
              id="support-message"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              placeholder={t('messagePlaceholder')}
              rows={6}
              maxLength={5000}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary request-support-submit" disabled={submitting}>
            {submitting ? t('submitting') : t('submit')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RequestSupport;
